/**
 * jQuery cyberitas onEnter plugin
 */
(function (jQuery) {
   "use strict";

   var iKeyCodeEnter = 13;

   jQuery.event.special.enter = {
      setup: function (data, namespaces) {
         var elem = this,
            $elem = jQuery(elem);
         $elem.on('keydown', jQuery.event.special.enter.handler);
      },

      teardown: function (namespaces) {
         var elem = this,
            $elem = jQuery(elem);
         $elem.unbind('keydown', jQuery.event.special.enter.handler);
      },

      handler: function (event) {
         var elem = this,
            $elem = jQuery(elem);
         if (event.keyCode === iKeyCodeEnter) {
            event.type = "enter";

            // let jQuery handle the triggering of "enter" event handlers
            // THIS FUNCTION IS UNDOCUMENTED AND DEPRECATED
            //jQuery.event.handle.apply(this, arguments);

            $(this).trigger(event, [arguments]);
         }
      }
   };

   jQuery.fn.enter = function (fn) {
      return this.on('enter', fn);
   };
}(jQuery));
